import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { getItem, getItemToken } from "../../../Utils/localStorageUtils";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
export default function PurchaseSubscription() {
  const { fetchOrganisationDetails } = useMyContext()
  const [orgDetails, setOrgdetails] = useState(null);
  const baseAppApi = process.env.REACT_APP_Base_Webnexs_URL
  const AppApi = process.env.REACT_APP_Baseurl
  const [contextData, setContextData] = useState(null);
  const [quoteData, setQuoteData] = useState(null);
  const [activeContextTab, setActiveContextTab] = useState("details");
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planTotal, setPlanTotal] = useState(0);
  const DEPLOYMENT_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_ID
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [selectedPlanSlug, setSelectedPlanSlug] = useState("");
  const [currency, setCurrency] = useState("INR");
  const typeLabels = {
    0: "Plugins",
    1: "Tools",
    2: "Apps",
  };

  const handleOrganisationDetails = async () => {
    try {
      const storedData = await fetchOrganisationDetails(DEPLOYMENT_ID);
      setOrgdetails(storedData?.data);
    } catch (error) {
      console.error("Error fetching organisation details:", error);
      return null;
    }
  };
  useEffect(() => {
    const fetchRequest = async () => {
      await handleOrganisationDetails();
    };
    fetchRequest();
  }, []);

  useEffect(() => {
    const fetchContext = async () => {
      try {
        const res = await axios.get(
          `${baseAppApi}/newpayment/subscriber/context/${orgDetails?.deployment_id}`,
          {
            params: {
              currency: currency,
            },
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const contextdetails = res.data.data;
        setContextData(contextdetails);
      } catch (e) {
        toast.error(e?.response?.data?.message || "Failed to load plans");
      }
    };

    if (baseAppApi && orgDetails) fetchContext();
  }, [baseAppApi, orgDetails, currency]);


  const fetchQuote = async (addonList, addonCycle, planSlug = "") => {
    try {
      const payload = {
        deployment_id: orgDetails?.deployment_id,
        addon_ids: addonList,
        billing_cycle: addonCycle,
        new_plan_slug: planSlug,
        currency_code: currency
      };

      const res = await axios.post(
        `${baseAppApi}/newpayment/subscriber/quote`,
        payload
      );

      setQuoteData(res.data.data);
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to load quote");
    }
  };

  const handlePurchase = async () => {
    try {
      const permission_ids = chosenAddons.map(id => {
        const addon = contextData?.overall_addons?.find(a => a.id === id);
        return addon?.permission_id;
      }).filter(Boolean);

      const selectedPlanObj = contextData?.overall_plans?.find(p => p.plan_slug === selectedPlanSlug);
      const free_permission_ids = selectedPlanObj?.free_included_addons?.map(addon => addon.permission_id) || [];

      const payload = {
        deployment_id: orgDetails?.deployment_id,
        user_id: getItem("user_id"),
        addon_ids: chosenAddons,
        permission_ids: [...new Set([...permission_ids, ...free_permission_ids])],
        billing_cycle: billingCycle,
        new_plan_slug: selectedPlanSlug,
        currency_code: currency
      };

      console.log(`payload ${JSON.stringify(payload)}`);

      const res = await axios.post(
        `${baseAppApi}/newpayment/subscriber/purchase`,
        payload
      );

      const response = res.data;

      if (!response.status) {
        toast.error(response.message || "Purchase Failed");
        return;
      }

      // Automatically trigger permission update on the local admin server
      if (payload.permission_ids.length > 0) {
        console.log(`Triggering local permission update for user ${payload.user_id} with permissions ${payload.permission_ids}`);
        try {
          console.log(`Triggering local permission update for user ${payload.user_id} with permissions ${payload.permission_ids}`);
          await axios.post(
            `${AppApi}/admin/role-permissions-update`,
            {
              user_id: payload.user_id,
              permission_id: payload.permission_ids
            },
            {
              headers: {
                Authorization: `Bearer ${getItemToken()}`,
                authorization: "7D96527535CC81A6282D"
              }
            }
          );

          console.log("Local permission update triggered successfully");
        } catch (err) {
          console.error("Failed to trigger local permission update:", err);
        }
      }

      let newTab = window.open("", "_blank");

      if (response.next_action === "stripe_checkout" && response.data.checkout_url) {
        newTab.location.href = response.data.checkout_url;
        return;
      }


      if (response.next_action === "cashfree_new_subscription" && response.initialize_payload) {
        const initRes = await axios.post(
          `${baseAppApi}/newpayment/initialize-payment`,
          response.initialize_payload
        );



        if (initRes.data.checkout_url) {
          newTab.location.href = initRes.data.checkout_url;
        }
      }
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Purchase Failed");
    }
  };

  useEffect(() => {
    if (selectedPlan || chosenAddons.length > 0) {
      // Use selectedPlanSlug directly as it holds the current plan slug state
      fetchQuote(chosenAddons, billingCycle, selectedPlanSlug);
    }
  }, [billingCycle, currency]);

  const selectedPlanObj = contextData?.overall_plans?.find(p => p.id === selectedPlan);
  const freePlanAddonPermissionIds = new Set(selectedPlanObj?.free_included_addons?.map(a => a.permission_id) || []);

  const addonTypes = [...new Set(contextData?.overall_addons?.map(a => a.add_on_type))];
  const [chosenAddons, setChosenAddons] = useState([]);

  const handleAddonToggle = (addon) => {
    const addonCycle = billingCycle;
    setChosenAddons(prev => {
      let updated;
      if (prev.includes(addon.id)) {
        updated = prev.filter(id => id !== addon.id);
      } else {
        updated = [...prev, addon.id];
      }
      fetchQuote(updated, addonCycle, selectedPlanSlug);
      return updated;
    });
  };

  const handlePlanSelect = (plan) => {
    const cycle = billingCycle;
    if (selectedPlan === plan.id) {
      setSelectedPlan(null);
      setSelectedPlanSlug("");
      setPlanTotal(0);
      if (activeContextTab === "plugins" || activeContextTab === "categories") {
        setActiveContextTab("plans");
      }
      fetchQuote(chosenAddons, cycle, "");
      return;
    }
    setSelectedPlan(plan.id);
    setSelectedPlanSlug(plan.plan_slug);
    const code = contextData.currency.code;
    const salePrice =
      cycle === "monthly"
        ? plan.pricing[code].monthly_price_sale ?? plan.pricing[code].monthly_price
        : plan.pricing[code].yearly_price_sale ?? plan.pricing[code].yearly_price;
    setPlanTotal(salePrice);
    fetchQuote(chosenAddons, cycle, plan.plan_slug);
  };


  return (
    <div className="sub-page">
      <div className="sub-left">
        <div className="sub-card">
          <div className="pricing-header-v3">
            <div>
              <h2 className="pricing-title-v3">Purchase Subscription</h2>
              <p className="pricing-subtitle-v3">Select your plan, billing term, and addons.</p>
            </div>

            <div className="pricing-switch-group-v3">
              <select value={currency} onChange={(e) => setCurrency(e.target.value)} className="currency-select">
                <option value="INR">INR</option>
                <option value="USD">USD</option>
              </select>

              {activeContextTab === "plans" && (
                <div className="billing-toggle">
                  <button className={`toggle-btn ${billingCycle === "monthly" ? "active" : ""}`} onClick={() => setBillingCycle("monthly")}>Monthly</button>
                  <button className={`toggle-btn ${billingCycle === "yearly" ? "active" : ""}`} onClick={() => setBillingCycle("yearly")}>Yearly</button>
                  <div className={`toggle-highlight ${billingCycle === "monthly" ? "toggle-left" : "toggle-right"}`} ></div>
                </div>
              )}
            </div>
          </div>
            <div className="sub-tabs">
              <button className={activeContextTab === "details" ? "tab active" : "tab"} onClick={() => setActiveContextTab("details")} >Subscription Details</button>
              <button className={activeContextTab === "plans" ? "tab active" : "tab"} onClick={() => setActiveContextTab("plans")}  >  Subscription Plans </button>
              {selectedPlan && (
                <button className={activeContextTab === "plugins" ? "tab active" : "tab"} onClick={() => setActiveContextTab("plugins")} > Plugins </button>
              )}
              {selectedPlan && (
                <button className={activeContextTab === "categories" ? "tab active" : "tab"} onClick={() => setActiveContextTab("categories")} > Categories </button>
              )}
            </div>
          <div className="tab-body">
            {activeContextTab === "details" && (
              <div className="subscription-container">
                <div className="sub-header">
                  <h3 className="sub-title">Subscription Overview</h3><span className="status-badge active">Active</span>
                </div>

                <div className="plan-card-modern">
                  <div>
                    <p className="plan-label">Current Plan</p>
                    <h4 className="plan-name">{contextData?.active.plan?.plan_name || "Trial"}</h4>
                  </div>
                  <span className="plan-tag">
                    {contextData?.active.plan?.plan_name ? "Paid" : "Trial"}
                  </span>
                </div>

                <div className="info-grid">
                  <div className="info-item">
                    <p className="info-label">Start Date</p>
                    <p className="info-value">{new Date(contextData?.billing.period_start).toLocaleDateString()} </p>
                  </div>

                  <div className="info-item">
                    <p className="info-label">End Date</p>
                    <p className="info-value">{new Date(contextData?.billing.period_end).toLocaleDateString()}</p>
                  </div>
                </div>
                <hr className="divider" />
                <div className="info-grid">
                  <div className="info-item">
                    <p className="info-label">Organization</p>
                    <p className="info-value">{contextData?.organization.org_name}</p>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Deployment ID</p>
                    <p className="info-value">{contextData?.subscriber.deployment_id}</p>
                  </div>
                  <div className="info-item full">
                    <p className="info-label">Email</p>
                    <p className="info-value">{contextData?.subscriber.email}</p>
                  </div>
                </div>

                {/* Cancel Button */}
                {/* <button className="cancel-btn" onClick={handleCancelSubscription}> Cancel Subscription  </button> */}

                <p id="status-message" style={{ marginTop: "10px", color: "#c00" }}></p>
              </div>
            )}

            {activeContextTab === "plans" && (
              <>
                <div className="d-flex justify-content-between">
                  <div className="">  <h3 className="section-title">Choose Your Plan</h3></div>
                </div>
                <div className="plans-grid compact">
                  {contextData?.overall_plans.map((plan) => {
                    const code = contextData?.currency.code;
                    const priceData = plan.pricing?.[code];
                    const isPurchased = plan.is_purchased;
                    if (!priceData) return null;
                    const mainPrice = billingCycle === "monthly" ? priceData.monthly_price_sale ?? priceData.monthly_price : priceData.yearly_price_sale ?? priceData.yearly_price;
                    const strikePrice = billingCycle === "monthly" ? priceData.monthly_price : priceData.yearly_price;
                    const isSelected = selectedPlan === plan.id;
                    return (
                      <div key={plan.id} className={`pricing-card small  ${isSelected ? "active" : ""}  ${isPurchased ? "disabled-card" : ""}`} onClick={() => { if (!isPurchased) handlePlanSelect(plan); }} >
                        <div className="card-top">
                          <h4 className="plan-name">{plan.plan_name}</h4>
                          {isPurchased ? (<span className="purchased-pill">Current Plan</span>
                          ) : isSelected ? (<BsCheckCircleFill className="plan-icon selected-icon" />
                          ) : (<BsCircle className="plan-icon" />)}
                        </div>
                        <div className="price-block">
                          <div className="price-main"> {contextData.currency.symbol} {mainPrice?.toLocaleString()} <span className="cycle">/{billingCycle}</span></div>
                          {(priceData.monthly_price_sale || priceData.yearly_price_sale) && (<div className="price-strike"> {contextData.currency.symbol} {strikePrice?.toLocaleString()}</div>)}
                        </div>
                        {plan.free_included_addons?.length > 0 && (
                          <div className="plan-addons mt-2">
                            <p className="small fw-semibold mb-1 text-muted">Includes Free Add-ons:</p>
                            <div className="d-flex flex-wrap gap-1">
                              {plan.free_included_addons.map((addon, index) => (
                                <span key={index} className="badge bg-light text-dark border p-1" style={{ fontSize: '10px' }}>
                                  {addon.name}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {activeContextTab === "plugins" && (
              <>
                <div className="dropdown-wrapper mb-4 d-flex align-items-center gap-3">
                  <label className="fw-semibold mb-0">Filter by Type:</label>
                  <div className="custom-dropdown">
                    <i className="bi bi-funnel-fill dd-icon"></i>
                    <select className="form-select dd-select" value={selectedType} onChange={e => setSelectedType(e.target.value)}>
                      <option value="">All Types</option>
                      {addonTypes.map(type => (
                        <option key={type} value={type}>{typeLabels[type] || `Type ${type}`} </option>
                      ))}
                    </select>
                  </div>
                </div>

                {(() => {
                  let filteredAddons = (contextData?.overall_addons || []).filter(
                    addon => !freePlanAddonPermissionIds.has(addon.permission_id)
                  );
                  if (selectedType !== "") {
                    filteredAddons = filteredAddons.filter(
                      addon => String(addon.add_on_type) === String(selectedType)
                    );
                  }

                  const purchasedHeadingText = selectedType ? `Purchased ${typeLabels[selectedType] || selectedType}` : "Purchased";
                  const availableHeadingText = selectedType ? `Available ${typeLabels[selectedType] || selectedType}` : "Available";
                  const purchased = filteredAddons.filter(a => a.is_purchased);
                  const available = filteredAddons.filter(a => !a.is_purchased);
                  const currencyCode = contextData?.currency?.code;
                  const currencySymbol = contextData?.currency?.symbol;
                  return (
                    <>
                      <div className="addons-section mb-4">
                        <h4 className="addons-title">{purchasedHeadingText}</h4>
                        {purchased.length === 0 && (<p className="text-muted small">No purchased in this type.</p>)}
                        {purchased.map(addon => {
                          const pricing = addon?.pricing?.[currencyCode] || {};
                          const regular = pricing.regular_price;
                          const sale = pricing.sale_price;

                          return (
                            <div key={addon.id} className="addon-card d-flex justify-content-between align-items-center p-3 mb-3 border rounded shadow-sm bg-light">
                              <div>
                                <h5 className="addon-name mb-1">{addon.name}</h5>
                                <p className="addon-price mb-0 fw-bold">{currencySymbol}{sale?.toLocaleString()} / month</p>
                              </div>
                              <span className="badge bg-success">Purchased</span>
                            </div>
                          );
                        })}
                      </div>

                      <div className="addons-section">
                        <h4 className="addons-title">{availableHeadingText}</h4>
                        {available.length === 0 && (<p className="text-muted small">No available in this type.</p>)}
                        {available.map(addon => {
                          const isSelected = chosenAddons.includes(addon.id);
                          const pricing = addon?.pricing?.[currencyCode] || {};
                          const regular = pricing.regular_price;
                          const sale = pricing.sale_price;

                          return (
                            <div key={addon.id} className="addon-card d-flex justify-content-between align-items-start p-3 mb-3 border rounded shadow-sm">
                              <div style={{ width: "70%" }}>
                                <h5 className="addon-name mb-1">{addon.name}</h5>
                                <div className="text-muted mb-1" style={{ fontSize: "14px" }} dangerouslySetInnerHTML={{ __html: addon.description }} />
                                <p className="addon-price mb-0">
                                  <span className="text-muted text-decoration-line-through me-2"> {currencySymbol}{regular?.toLocaleString()} </span>
                                  <span className="fw-bold text-success">   {currencySymbol}{sale?.toLocaleString()}</span>
                                  <span className="text-muted"> / month</span>
                                </p>
                              </div>
                              <button className={`btn btn-sm ${isSelected ? "btn-outline-danger" : "btn-outline-primary"}`} onClick={() => handleAddonToggle(addon)} >{isSelected ? "Remove" : "Add"}</button>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  );
                })()}
              </>
            )}

            {activeContextTab === "categories" && (
              <>
                <h3 className="section-title">Categories</h3>
                <div className="d-flex gap-2 flex-wrap mb-4">
                  {contextData?.plugin_categories?.map(cat => (
                    <button key={cat.id} className={`btn btn-sm ${activeCategory === cat.slug ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setActiveCategory(cat.slug)}> {cat.name} </button>
                  ))}
                </div>

                {activeCategory && (
                  <div className="addons-section">
                    <h4 className="addons-title text-capitalize">{activeCategory} Add-ons</h4>
                    {contextData?.overall_addons_by_category
                      ?.filter(c => c.slug === activeCategory)
                      ?.flatMap(c => c.addons)
                      ?.filter(addon => !freePlanAddonPermissionIds.has(addon.permission_id))
                      ?.map(addon => {
                        const isSelected = chosenAddons.includes(addon.id);
                        const currencyCode = contextData?.currency?.code;
                        const currencySymbol = contextData?.currency?.symbol;
                        const pricing = addon?.pricing?.[currencyCode] || {};
                        const regular = pricing?.regular_price || 0;
                        const sale = pricing?.sale_price || 0;

                        return (
                          <div key={addon.id} className="addon-card d-flex justify-content-between align-items-start p-3 mb-3 border rounded shadow-sm">
                            <div style={{ width: "70%" }}>
                              <h5 className="addon-name mb-1">{addon.name}</h5>
                              <div className="addon-description mb-2 text-muted" style={{ fontSize: "14px" }} dangerouslySetInnerHTML={{ __html: addon.description }}></div>
                              <p className="addon-price mb-0">
                                <span className="text-muted text-decoration-line-through me-2">{currencySymbol}{regular?.toLocaleString()}</span>
                                <span className="fw-bold text-success"> {currencySymbol}{sale?.toLocaleString()}</span>
                                <span className="text-muted"> / month</span>
                              </p>
                            </div>
                            <div className="d-flex flex-column align-items-end gap-2">
                              {addon.is_purchased && (<span className="badge bg-success">Purchased</span>)}
                              {!addon.is_purchased && (
                                <button className={`btn btn-sm ${isSelected ? "btn-outline-danger" : "btn-outline-primary"}`} onClick={() => handleAddonToggle(addon)}>{isSelected ? "Remove" : "Add"}</button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {quoteData &&
        <div className="sub-right">
          <div className="checkout-card-modern">
            <h3 className="checkout-title">Pricing Summary</h3>
            <div className="checkout-row header-row">
              <span>Plan</span>
              <span className="value">{contextData?.active.plan?.plan_name || "trial"}</span>
            </div>
            <hr />
            {quoteData ? (
              <>
                <div className="checkout-row">
                  <span>Current Plan ({quoteData.billing_cycle})</span>
                  <span className="value">{quoteData.currency.symbol}{quoteData.base_plan_amount?.toLocaleString()}</span>
                </div>
                {quoteData?.new_plan_price > 0 &&
                  <div className="checkout-row">
                    <span>Updated Plan ({quoteData.billing_cycle})</span>
                    <span className="value"> {quoteData.currency.symbol}{quoteData.new_plan_price?.toLocaleString()}</span>
                  </div>
                }
                <div className="checkout-row">
                  <span>Add-ons</span>
                  <span className="value">{quoteData.currency.symbol}{quoteData.addon_price?.toLocaleString()}</span>
                </div>

                <div className="divider-light"></div>
                {quoteData.immediate_charge > 0 && (
                  <div className="checkout-row highlight-row">
                    <span>Immediate Charge</span>
                    <span className="value">{quoteData.currency.symbol}{quoteData.immediate_charge?.toLocaleString()}  </span>
                  </div>
                )}
                {selectedPlanSlug && (
                  <>
                    <div className="checkout-row subtle-row">
                      <span>Next Cycle Total</span>
                      <span className="value">  {quoteData.currency.symbol}{quoteData.next_cycle_total?.toLocaleString()}</span>
                    </div>
                    <hr />
                    <div className="checkout-row total-row">
                      <span>Grand Total — Next billing</span>
                      <span className="value total">{quoteData.currency.symbol}{quoteData.projected_next_cycle_grand_total?.toLocaleString()}</span>
                    </div>
                    <p className="next-billing-text">  Next billing on <strong>{quoteData.next_billing_date}</strong> </p>
                  </>
                )}
              </>
            ) : (<p className="text-muted small">Select addons to view updated pricing…</p>)}
            <button className="btn-primary full mt-3" onClick={handlePurchase}>Pay {quoteData.currency.symbol}{quoteData.immediate_charge?.toLocaleString()} now</button>
          </div>
        </div>
      }

    </div>
  );
}

